import { Col } from 'reactstrap';
import styled from 'styled-components';

export const ColStyled = styled(Col)`
    margin-top: 0px;
    padding: 0px 10px 0px 0px;
`;
